import { pbdkf2 } from "./OstreonEncryption"
import { submitCaptcha } from "./captcha"
import config from "../config"
const base_url = config.base_url
export const fetchChangeEmail = (email, password) =>{
    return new Promise(async (resolve, reject) => {
        try {
            if (!email || !password) throw new Error ('Email and Password should be provided')
            const [pbdkf2hash, ] = await pbdkf2(password, 'OSTREON', 100000, 32*8)
            const captcha_token = await submitCaptcha()
            const function_ = fetch(base_url+'user/change/email', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `token=${captcha_token}&newEmail=${email}&password=${pbdkf2hash}`,
                credentials:'include'
            }) 
            resolve(function_)
        } catch (error) {
            reject(error)
        }
        
    })
    
}
export const ChangeEmailOTP = (otp_token) =>{
    return new Promise(async (resolve, reject) => {
        try {
            if (!otp_token) throw new Error('OTP Token is missing')
            const captcha_token = await submitCaptcha()
            const function_ = fetch(base_url+'user/change/email/verify', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `token=${captcha_token}&otp_token=${otp_token}`,
                credentials:'include'
            }) 
            resolve(function_)
        } catch (error) {
            reject(error)
        }
        
    })
}

export const fetchChangePassword = (password)=>{
    return new Promise(async (resolve, reject) => {
        try {
            if (!password) throw new Error ('NoOTP')
            const [pbdkf2hash, ] = await pbdkf2(password, 'OSTREON', 100000, 32*8)
            const captcha_token = await submitCaptcha()
            const function_ = fetch(base_url+'user/change/password', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `token=${captcha_token}&&password=${pbdkf2hash}`,
                credentials:'include'
            }) 
            resolve(function_)
        } catch (error) {
            console.log(error)
            reject(error)
        }
        
    })
}
export const ChangePasswordOTP = (otp_token) =>{
    return new Promise(async (resolve, reject) => {
        try {
            if (!otp_token) throw new Error('OTP Code is missing')
            const captcha_token = await submitCaptcha()
            const function_ = fetch(base_url+'user/change/password/verify', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `token=${captcha_token}&otp_token=${otp_token}`,
                credentials:'include'
            }) 
            resolve(function_)
        } catch (error) {
            reject(error)
        }
        
    })
}